import { render, staticRenderFns } from "./ScheduleDemo.vue?vue&type=template&id=2960f95a&"
import script from "./ScheduleDemo.vue?vue&type=script&lang=js&"
export * from "./ScheduleDemo.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleDemo.vue?vue&type=style&index=0&id=2960f95a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports